module.exports = __webpack_public_path__ + "static/bfp_slide_steps-18315afde0bd91aa64a5c7ff4b6bdd9f.jpg";